const types = {
  FETCH_FORMULARY: "FETCH_FORMULARY",
  CHANGE_FORMULARY_INPUT: "CHANGE_FORMULARY_INPUT",
  SET_CURRENT_FORMULARY: "SET_CURRENT_FORMULARY",
  VALIDATE_CURRENT_STEP: "VALIDATE_CURRENT_STEP",
  UPDATE_VISITED_STEP_FLAG: "UPDATE_VISITED_STEP_FLAG"
}

export default types
